module.exports = __webpack_public_path__ + "static/media/service_1.2fee68d6.jpg";